export const METHODS = {
    Cash: 1,
    Card: 2
};

export const METHODS_STRING = {
    [METHODS.Cash]: 'Безналичный счет',
    [METHODS.Card]: 'Банковская карта, СБП'
};

export const BTN_NAME = {
    [METHODS.Cash]: 'Сформировать счет',
    [METHODS.Card]: 'Перейти к оплате'
}


// WEBPACK FOOTER //
// ./src/modules/home/pricing/constants.js